import { useEffect, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { hasCompleteProfile, profileReturnTo } from '../lib/profileCompletion'
import { LoadingState } from './LoadingState'

export function ProfileCompletionGate({ children }: { children: ReactNode }) {
  const { user, profile, loading, accountRemoved, revalidateSession } = useAuth()
  const location = useLocation()
  useEffect(() => { revalidateSession?.() }, [location.pathname, location.search, revalidateSession])
  if (accountRemoved) return location.pathname === '/account-rimosso' ? children : <Navigate to="/account-rimosso" replace />
  if (location.pathname === '/account-rimosso') return children
  if (loading) return <LoadingState label="Carico il tuo profilo…" />
  if (!user || location.pathname === '/completa-profilo') return children
  if (!profile) return location.pathname === '/profilo' ? children : <Navigate to="/profilo" replace state={location.state} />
  if (hasCompleteProfile(profile)) return children
  const requestedPath = location.pathname === '/login'
    ? new URLSearchParams(location.search).get('returnTo')
    : `${location.pathname}${location.search}`
  const returnTo = profileReturnTo(requestedPath)
  return <Navigate to={`/completa-profilo?returnTo=${encodeURIComponent(returnTo)}`} replace state={location.state} />
}
